class TilesCalculator extends HTMLElement {
  constructor() {
    super();

    // raw dataset values are strings → parse once
    this.dimensions = this.dataset.dimensions;
    this.widthCm = parseFloat(this.dataset.widthCm) || 0;
    this.heightCm = parseFloat(this.dataset.heightCm) || 0;

    this.perTilePrice = parseFloat(this.dataset.perTilePrice) || 0;
    this.perTileCompare = parseFloat(this.dataset.perTileCompare) || 0;
    this.pricePerSqm = parseFloat(this.dataset.pricePerSqm) || 0;
    this.perTileSqm = parseFloat(this.dataset.perTileSqm) || 0;


    this.wastage = parseFloat(this.dataset.wastage) || 0;

    this.sqmInput = this.querySelector('[data-sqm-input]');
    this.tilesInput = this.querySelector('[data-tiles-input]');

    this.checkbox = this.querySelector('.switch [type="checkbox"]');

    this.totalPriceRow = this.querySelector('[data-total-price-row]');
    this.totalPrice = this.querySelector('[data-total-price]');

    this.btn__add_body1 = this.querySelector('.btn__add_body1')
    this.btn__add_body2 = this.querySelector('.btn__add_body2')
    this.area_price = this.querySelector('[area-price]')

    
    this.wallIndex1 = 1;
    this.wallIndex2 = 1;

    // 👇 the key: store a base sqm that never includes the +10%
    this.baseSqm = parseFloat(this.sqmInput?.value) || 0;

    this.setAccessibility();


    this.area__category_1 = this.querySelector(".area__category_1 .calculate-area-inner");
    this.area__category_2 = this.querySelector(".area__category_2 .calculate-area-inner");

    this.Category1setAccessibility();
    this.Category2setAccessibility();
  }

  setAccessibility() {
    this.sqmInput.addEventListener('change', () => {
      // User typed sqm → update base and recalc
      this.baseSqm = parseFloat(this.sqmInput.value) || 0;
      this.settiles();
    });

    this.tilesInput.addEventListener('change', () => {
      // User typed tiles → convert to sqm, make THAT the base, then recalc
      const totalsqm = (parseFloat(this.tilesInput.value) || 0) * this.perTileSqm;
      this.baseSqm = this.round2(totalsqm);
      this.sqmInput.value = this.baseSqm;
      this.settiles();
    });

    this.checkbox.addEventListener('change', () => {
      // Toggle wastage → recalc from the same base
      this.settiles();
    });

    this.btn__add_body1.addEventListener('click', () => {
      this.addWallCategory1()
    });

    this.btn__add_body2.addEventListener('click', () => {
      this.addWallCategory2()
    });


    // Selectors scoped to this component
    const openBtn = this.querySelector('.cal___icon_wrapper');
    const closeBtn = this.querySelector('.area__close-icon');
    const overlay = this.querySelector('.calculate-area-popup-overlay');
    const popup = this.querySelector('.calculate-area-popup-row');

    const popup_add_to_cart = popup.querySelector('.calculate-button');

    if (popup_add_to_cart) {
      popup_add_to_cart.addEventListener('click', () => {
        document.querySelector('html').classList.remove('hidden');
        popup.classList.remove('active');
        document.querySelector('.product-block-list__wrapper .product-form__add-button').click()
      });
    }

    if (openBtn && popup) {
      openBtn.addEventListener('click', () => {
        document.querySelector('html').classList.add('hidden');
        popup.classList.add('active');
        this.updateTotalCategory();
      });
    }

    if (closeBtn && popup) {
      closeBtn.addEventListener('click', () => {
        document.querySelector('html').classList.remove('hidden');
        popup.classList.remove('active');
      });
    }

    if (overlay && popup) {
      overlay.addEventListener('click', () => {
        document.querySelector('html').classList.remove('hidden');
        popup.classList.remove('active');
      });
    }

    // Toggle parent .open on subtract___wrapper click (scoped to this component)
    this.querySelectorAll(".subtract___wrapper").forEach((element) => {
      element.addEventListener("click", function() {
        this.parentElement.classList.toggle("open");
      });
    });
  }

  Category1setAccessibility(){
    const remove = this.area__category_1.querySelectorAll('.remove__row');

    remove.forEach((elements, idx, array) => {
      if (elements.getAttribute('listener') !== 'true') {
        elements.addEventListener('click', (event) => {
            this.removeWallCategory1(event);
            this.updateTotalCategory();
        });
        elements.setAttribute('listener', 'true');
      }
    });

    const area__category_1 = this.area__category_1.querySelectorAll('.calculate-area--row');

    area__category_1.forEach((elements, idx, array) => {
      var length = elements.querySelector('[name="length"]');

      if (length.getAttribute('listener') !== 'true') {
        length.addEventListener('change', (event) => {
            this.updateAreaCategory1(event);
        });
        length.setAttribute('listener', 'true');
      }

      var width = elements.querySelector('[name="width"]');

      if (width.getAttribute('listener') !== 'true') {
        width.addEventListener('change', (event) => {
            this.updateAreaCategory1(event);
        });
        width.setAttribute('listener', 'true');
      }
    });
  }

  updateAreaCategory1(event){
    var input = event.target
    const row = input.closest(".calculate-area--row");
    const inputs = row.querySelectorAll("input");
    const length = parseFloat(inputs[0].value) || 0;
    const width = parseFloat(inputs[1].value) || 0;
    const area = length * width;
    row.querySelector(".row__info-total span").innerText = area.toFixed(2);

    this.updateTotalCategory();
  }

  removeWallCategory1(event){
    event.target.closest('.calculate-area--row')?.remove();
    this.wallIndex1--;
  }

  addWallCategory1(){
    this.wallIndex1++;
    const container = this.area__category_1;
    const row = document.createElement("div");
    row.className = "calculate-area--row";
    row.innerHTML = `
      <span class="row__title">Wall/Floor ${this.wallIndex1}</span>
      <div class="area--row__info">
          <span class="area--row--input">
            <label class="area--row--input-title">Length(m)</label>
            <input type="number" name="length" placeholder="0">
          </span>
          <span class="multiply__icon icon_area">
              <svg xmlns="http://www.w3.org/2000/svg" class="inline-block fill-current w-5 h-5 !w-[13px]" viewBox="0 0 24 24"><path d="M18.295 5.705a.998.998 0 0 1 0 1.41L13.41 12l4.885 4.885a.997.997 0 1 1-1.41 1.41L12 13.41l-4.885 4.885a.997.997 0 1 1-1.41-1.41L10.59 12 5.705 7.115a.997.997 0 0 1 1.41-1.41L12 10.59l4.885-4.885a.997.997 0 0 1 1.41 0Z"></path></svg>
          </span>
          <span class="area--row--input">
            <label class="area--row--input-title">Width(m)</label>
            <input type="number" name="width" placeholder="0">
          </span>
          <span class="equal__icon icon_area">=</span>
          <div class="row__info-total">
              <label class="area--row--input-title">Area(m²)</label>
              <span>0.00</span>
          </div>
          <span class="remove__row">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.47 6.47 2 12 2C17.53 2 22 6.47 22 12C22 17.53 17.53 22 12 22C6.47 22 2 17.53 2 12ZM16.295 16.295C16.6844 15.9056 16.6844 15.2744 16.295 14.885L13.41 12L16.295 9.115C16.6844 8.72564 16.6844 8.09436 16.295 7.705C15.9056 7.31564 15.2744 7.31564 14.885 7.705L12 10.59L9.115 7.705C8.72564 7.31564 8.09436 7.31564 7.705 7.705C7.31564 8.09436 7.31564 8.72564 7.705 9.115L10.59 12L7.705 14.885C7.31564 15.2744 7.31564 15.9056 7.705 16.295C8.09436 16.6844 8.72564 16.6844 9.115 16.295L12 13.41L14.885 16.295C15.2744 16.6844 15.9056 16.6844 16.295 16.295Z" class="fill-pdp-purchaseCard-calculatorPopup-body-crossIcon"></path>
            </svg>
          </span>
      </div>
    `;
    container.appendChild(row);
    this.Category1setAccessibility();
  }

  Category2setAccessibility(){
    const remove = this.area__category_2.querySelectorAll('.remove__row');

    remove.forEach((elements, idx, array) => {
      if (elements.getAttribute('listener') !== 'true') {
        elements.addEventListener('click', (event) => {
            this.removeWallCategory2(event);
            this.updateTotalCategory();
        });
        elements.setAttribute('listener', 'true');
      }
    });

    const area__category_2 = this.area__category_2.querySelectorAll('.calculate-area--row');

    area__category_2.forEach((elements, idx, array) => {
      var length = elements.querySelector('[name="length"]');

      if (length.getAttribute('listener') !== 'true') {
        length.addEventListener('change', (event) => {
            this.updateAreaCategory2(event);
        });
        length.setAttribute('listener', 'true');
      }

      var width = elements.querySelector('[name="width"]');

      if (width.getAttribute('listener') !== 'true') {
        width.addEventListener('change', (event) => {
            this.updateAreaCategory2(event);
        });
        width.setAttribute('listener', 'true');
      }
    });
  }

  updateAreaCategory2(event){
    var input = event.target
    const row = input.closest(".calculate-area--row");
    const inputs = row.querySelectorAll("input");
    const length = parseFloat(inputs[0].value) || 0;
    const width = parseFloat(inputs[1].value) || 0;
    const area = length * width;
    row.querySelector(".row__info-total span").innerText = area.toFixed(2);

    this.updateTotalCategory();
  }

  updateTotalCategory(){
    let total_1 = 0;
    this.area__category_1.querySelectorAll('.calculate-area--row .row__info-total span').forEach(span => {
      total_1 += parseFloat(span.innerHTML) || 0;
    });
    this.area__category_1.parentElement.querySelector(".calculate-area-total").innerText = "Total = " + total_1.toFixed(2);
    
    let total_2 = 0;
    this.area__category_2.querySelectorAll('.calculate-area--row .row__info-total span').forEach(span => {
      total_2 += parseFloat(span.innerHTML) || 0;
    });

    var final_total = total_1 - total_2;

    if(final_total <= 0){
      final_total = 0;
    }

    this.area__category_2.parentElement.querySelector(".calculate-area-total").innerText = "Total = " + final_total.toFixed(2);

    // User typed tiles → convert to sqm, make THAT the base, then recalc
    const totalsqm = final_total;
    this.baseSqm = this.round2(totalsqm);
    this.sqmInput.value = this.baseSqm;
    this.settiles();
  }

  removeWallCategory2(event){
    event.target.closest('.calculate-area--row')?.remove();
    this.wallIndex2--;
  }

  addWallCategory2(){
    this.wallIndex2++;
    const container = this.area__category_2;
    const row = document.createElement("div");
    row.className = "calculate-area--row";
    row.innerHTML = `
      <span class="row__title">Window/Door ${this.wallIndex2}</span>
      <div class="area--row__info">
          <span class="area--row--input">
            <label class="area--row--input-title">Length(m)</label>
            <input type="number" name="length" placeholder="0">
          </span>
          <span class="multiply__icon icon_area">
              <svg xmlns="http://www.w3.org/2000/svg" class="inline-block fill-current w-5 h-5 !w-[13px]" viewBox="0 0 24 24"><path d="M18.295 5.705a.998.998 0 0 1 0 1.41L13.41 12l4.885 4.885a.997.997 0 1 1-1.41 1.41L12 13.41l-4.885 4.885a.997.997 0 1 1-1.41-1.41L10.59 12 5.705 7.115a.997.997 0 0 1 1.41-1.41L12 10.59l4.885-4.885a.997.997 0 0 1 1.41 0Z"></path></svg>
          </span>
          <span class="area--row--input">
            <label class="area--row--input-title">Width(m)</label>
            <input type="number" name="width" placeholder="0">
          </span>
          <span class="equal__icon icon_area">=</span>
          <div class="row__info-total">
              <label class="area--row--input-title">Area(m²)</label>
              <span>0.00</span>
          </div>
          <span class="remove__row">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.47 6.47 2 12 2C17.53 2 22 6.47 22 12C22 17.53 17.53 22 12 22C6.47 22 2 17.53 2 12ZM16.295 16.295C16.6844 15.9056 16.6844 15.2744 16.295 14.885L13.41 12L16.295 9.115C16.6844 8.72564 16.6844 8.09436 16.295 7.705C15.9056 7.31564 15.2744 7.31564 14.885 7.705L12 10.59L9.115 7.705C8.72564 7.31564 8.09436 7.31564 7.705 7.705C7.31564 8.09436 7.31564 8.72564 7.705 9.115L10.59 12L7.705 14.885C7.31564 15.2744 7.31564 15.9056 7.705 16.295C8.09436 16.6844 8.72564 16.6844 9.115 16.295L12 13.41L14.885 16.295C15.2744 16.6844 15.9056 16.6844 16.295 16.295Z" class="fill-pdp-purchaseCard-calculatorPopup-body-crossIcon"></path>
            </svg>
          </span>
      </div>
    `;
    container.appendChild(row);
    this.Category2setAccessibility();
  }

  setsqm() {
    // kept for compatibility: tiles -> sqm, then recalc
    const totalsqm = (parseFloat(this.tilesInput.value) || 0) * this.perTileSqm;
    this.baseSqm = this.round2(totalsqm);
    this.sqmInput.value = this.baseSqm;
    this.settiles();
  }

  settiles() {
    this.totalPriceRow.classList.add('hide');

    const totalTiles = this.totalTiles();         // uses baseSqm (+10% only if checked)
    const totalsqm = this.titalsqm(totalTiles);   // snapped sqm for the tile count

    // reflect snapped values in the UI
    this.sqmInput.value = totalsqm;
    this.tilesInput.value = totalTiles;

    this.setPrice(totalsqm, totalTiles);
  }

  setPrice(_totalsqm, totalTiles) {
    const totalPrice = totalTiles * this.perTilePrice;
    this.totalPrice.textContent = "£" + this.round2(totalPrice).toFixed(2);
    this.area_price.textContent = "£" + this.round2(totalPrice).toFixed(2);
    this.closest('form').querySelector('[name="quantity"]').value = totalTiles;
    this.totalPriceRow.classList.remove('hide');
  }

  titalsqm(totalTiles) {
    return this.round2(totalTiles * this.perTileSqm).toFixed(2);
  }

  totalTiles() {
    // always compute from the original base (what user intended)
    let sqm = this.baseSqm;
    if (this.checkbox.checked) {
      sqm = sqm * this.wastage; // add wastage
    }
    return Math.ceil(sqm / this.perTileSqm || 0);
  }

  round2(n) {
    return Math.round((Number(n) + Number.EPSILON) * 100) / 100;
  }
}

customElements.define('tiles-calculator', TilesCalculator);


// calculator popup trigger
// $(".cal___icon_wrapper").click(function(){
//   $('body').addClass('hidden');
//   $('body').find('.calculate-area-popup-row').addClass('active');
// });
// $(".area__close-icon").click(function(){
//   $('body').removeClass('hidden');
//   $('body').find('.calculate-area-popup-row').removeClass('active');
// });
// $(".calculate-area-popup-overlay").click(function(){
//   $('body').removeClass('hidden');
//   $('body').find('.calculate-area-popup-row').removeClass('active');
// });